import {
  WorkshopsView,
  WorkshopsImportingView,
  WorkshopAddClient,
  WorkshopDetailView,
  WorkshopEditClient,
  WorkshopClientReplaceParticipant,
  DashboardView,
  RevisionsView,
} from ".";

export const adminRoutes = [
  {
    path: "/admin/workshops",
    name: "workshops",
    component: WorkshopsView,
  },
  {
    path: "/admin/workshops/importing",
    name: "workshopsImportingView",
    component: WorkshopsImportingView,
  },
  {
    path: "/admin/workshops/:workshopId/detail",
    name: "workshopDetailView",
    component: WorkshopDetailView,
  },
  {
    path: "/admin/workshops/:workshopId/client/add",
    name: "workshopAddClient",
    component: WorkshopAddClient,
  },
  {
    path: "/admin/workshops/:workshopId/client/:companyId/edit",
    name: "workshopEditClient",
    component: WorkshopEditClient,
  },
  {
    path: "/admin/workshops/:workshopId/client/:companyId/participant/:participantId/replace",
    name: "workshopClientReplaceParticipant",
    component: WorkshopClientReplaceParticipant,
  },
  {
    path: "/admin/dashboard",
    name: "dashboard",
    component: DashboardView,
  },
  {
    path: "/admin/workshops/:workshopId/client/:companyId/revisions",
    name: "responseStatus",
    component: RevisionsView,
  },
];
